//按钮权限
export default {
    //绑定到元素触发的钩子函数(el当前对象,binding当前绑定属性)
    inserted(el, bindings) {
        console.log(el, bindings, 111);
        //当前元素绑定的数据
        const has = bindings.value
        console.log(has);
        // console.log('绑定对象',el,bindings)
        //判断权限是否存在
        const hasPermission = arr.includes(has)
        //如果不存在进行隐藏
        if (!hasPermission) {
            el.style.display = "none"
            // 如果绑定的是bind,需要异步获取下。bind它会在渲染完毕之前触发所以将删除元素改为异步
            setTimeout(() => {
                //删除当前元素
                el.parentNode.removeChild(el)
            }, 0);
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/hasMenu.js